import { makeObservable, observable, action, computed } from 'mobx';

class ProductDimensionsStore {
  dimensions = {}; // Текущие размеры продукта
  originalDimensions = {}; // Исходные размеры из БД
  selectedProductId = null;

  constructor() {
    makeObservable(this, {
      dimensions: observable,
      originalDimensions: observable,
      selectedProductId: observable,
      
      setDimensions: action,
      updateDimensionValue: action,
      resetDimensions: action,
      clearDimensions: action,
      
      hasDimensions: computed,
      sortedDimensions: computed,
      isModified: computed,
    });
  }

  get hasDimensions() {
    return Object.keys(this.dimensions).length > 0;
  }

  get sortedDimensions() {
    return Object.entries(this.dimensions).sort(([keyA, valueA], [keyB, valueB]) => {
      // Высота всегда первая
      if (valueA.is_height) return -1;
      if (valueB.is_height) return 1;
      
      // Остальные по алфавиту
      return keyA.localeCompare(keyB);
    });
  }

  get isModified() {
    if (!this.hasDimensions) return false;
    
    return Object.keys(this.dimensions).some(key => {
      return this.dimensions[key].value !== this.originalDimensions[key]?.value;
    });
  }

  setDimensions = (productId, dimensionsData) => {
    this.selectedProductId = productId;
    this.dimensions = { ...dimensionsData };
    
    // Сохраняем исходные значения для проверки изменений
    this.originalDimensions = {};
    Object.keys(dimensionsData).forEach(key => {
      this.originalDimensions[key] = { ...dimensionsData[key] };
    });
  };

  updateDimensionValue = (dimensionKey, newValue) => {
    if (this.dimensions[dimensionKey]) {
      if (newValue === '') {
        this.dimensions[dimensionKey].value = '';
        return;
      }

      const parsedValue = parseInt(newValue, 10);
      if (Number.isNaN(parsedValue)) {
        return;
      }

      this.dimensions[dimensionKey].value = parsedValue;
    }
  };

  resetDimensions = () => {
    if (!this.hasDimensions) return;
    
    Object.keys(this.dimensions).forEach(key => {
      if (this.originalDimensions[key]) {
        this.dimensions[key].value = this.originalDimensions[key].value;
      }
    });
  };

  clearDimensions = () => {
    this.dimensions = {};
    this.originalDimensions = {};
    this.selectedProductId = null;
  };

  // Получить данные для расчета площади стекла
  getGlassAreas = () => {
    const areas = {};
    
    Object.entries(this.dimensions).forEach(([key, dimension]) => {
      if (dimension.has_glass) {
        areas[key] = {
          label: dimension.label,
          value: dimension.value === '' ? 0 : dimension.value,
          is_height: dimension.is_height,
        };
      }
    });
    
    return areas;
  };

  // Получить итоговые размеры для отправки в конфигуратор
  getFinalDimensions = () => {
    const result = {};
    
    Object.entries(this.dimensions).forEach(([key, dimension]) => {
      result[key] = {
        label: dimension.label,
        value: dimension.value === '' ? 0 : dimension.value,
        has_glass: dimension.has_glass,
        is_height: dimension.is_height,
      };
    });
    
    return result;
  };
}

const productDimensionsStore = new ProductDimensionsStore();
export default productDimensionsStore; 
